<script setup lang="ts">
import { computed, ref } from 'vue'
import { colors, Element } from 'wepin-vue-component'
import DepthIcon from '@/components/icon/DepthIcon.vue'
import { defaultCoinIcon } from '@/const'
import { useSettingsStore } from '@/stores'
import { AccountToken, type BaseAccount } from '@/types'

const props = defineProps<{
  account: BaseAccount
  isToken: boolean
}>()
const settingStore = useSettingsStore()
const handle = computed<string>(() => {
  if (props.isToken && settingStore.accountLayout.group) return ''
  else return 'handle'
})
const showSubIcon = computed<boolean>(() => {
  return props.account instanceof AccountToken
})

const isErrorIcon = ref(false)

const onErrorIcon = () => {
  isErrorIcon.value = true
}

const getIconUrl = computed(() => {
  if (isErrorIcon.value) {
    return defaultCoinIcon
  }
  return props.account.coin?.iconUrl
})

const isErrorSubIcon = ref(false)

const onErrorSubIcon = () => {
  isErrorSubIcon.value = true
}

const getSubIconUrl = computed(() => {
  if (isErrorSubIcon.value) {
    return defaultCoinIcon
  }
  return props.account.coin?.coin?.iconUrl
})
</script>

<template>
  <div class="list" :class="isToken ? 'token' : ''">
    <div class="list-item">
      <DepthIcon v-if="isToken" :width="20" :height="20" />
      <div class="item-img">
        <img :src="getIconUrl" @error="onErrorIcon()" />
        <img
          v-if="showSubIcon"
          class="sub-icon"
          :src="getSubIconUrl"
          @error="onErrorSubIcon()"
        />
      </div>
      <div class="item-info">
        <span>{{ account.coin?.name }}</span>
        <span>{{ account.label }}</span>
      </div>
    </div>
    <div class="list-hamburger" :class="handle">
      <Element
        name="Hamburger"
        :color="colors.currentThemeRef.value.grey_bbb"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'wepin-vue-component/src/styles/typeface.module.scss';

.container {
  position: relative;
}
.list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: {
    left: 20px;
    right: 20px;
    top: 15px;
    bottom: 15px;
  }
  & > .list-hamburger {
    z-index: 100;
    cursor: pointer;
  }
  & > .list-item {
    display: flex;
    align-items: center;
    position: relative;
    gap: 10px;
    .item-img {
      display: flex;
      width: 46px;
      & > img {
        justify-self: flex;
        width: 36px;
        height: 36px;
        border-radius: 50%;
      }
      & > .sub-icon {
        position: absolute;
        width: 20px;
        height: 20px;
        bottom: 0;
        right: 0;
      }
    }
    & > .item-info {
      display: flex;
      flex-direction: column;
      & > span:nth-child(1) {
        @include typeface('Title_18');
        color: var(--grey_111);
      }
      & > span:nth-child(2) {
        @include typeface('Paragraph_16_r');
        color: var(--grey_999);
      }
    }
  }
}
</style>
